export default __webpack_public_path__ + "static/media/VueLogo.136a4039.svg";